/* eslint-disable indent,import/prefer-default-export */
import fr from 'facet-rest';

// TODO: Option ordering
const hiddenFieldNames = [
  'status',
];

export const ExternalFormOverride = fr.metaOverride()
    .nameOverride(name => hiddenFieldNames.includes(name), { hidden: true })
    .nameOverride('reviewed', { ordinal: 3 })
    .done();
